import React, { PropTypes,Component } from 'react';
import Auth from '../modules/Auth';

class FacebookLogin extends Component {

	constructor(props){
		super(props);
		this.state = {message:''};

	}

	static propTypes = {
		appId: PropTypes.string.isRequired,
    onStatusChange: PropTypes.func.isRequired
	}

	 static defaultProps = {
	 	locale: 'en_US',
	 	version: 'v2.8',
	 	xfbml: true
	 }

	componentDidMount() {
		const {appId, locale, version, xfbml} = this.props;
    var self = this;

	window.fbAsyncInit = () => {
      	FB.init({ // eslint-disable-line no-undef
       		 appId: appId,
        	xfbml: xfbml,
        	version: version,
        	cookie: true,
        	//redirect_uri: 'http://tests.godieboy.com:3000'
      		});



		FB.getLoginStatus(function(response) { // eslint-disable-line no-undef
    		self.props.onStatusChange(response);
			 });

    FB.Event.subscribe('auth.statusChange',  // eslint-disable-line no-undef
            this.props.onStatusChange.bind(this));
   		};



   	((d, s, id) => { // eslint-disable-line id-length
      const element = d.getElementsByTagName(s)[0];
      const fjs = element;
      let js = element;
      if (d.getElementById(id)) {return;}
      js = d.createElement(s); js.id = id;
      js.src = `//connect.facebook.net/${locale}/sdk.js`;
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');

    	if(window.FB != null) {
    			/*window.FB.Event.subscribe('auth.logout',
         		window.FB.onLogout.bind(this));*/
      			FB.Event.subscribe('auth.statusChange',  // eslint-disable-line no-undef
         		this.props.onStatusChange.bind(this));
    	}

	}



  fbLogin(){
   	FB.login((response) => { // eslint-disable-line no-undef
   		console.log(response);
   	},{scope: 'public_profile, email'});
   }

	componentDidUpdate() {
		console.log('se update...');
    if (window.FB) {
     	 window.FB.XFBML.parse();
     	 this.FB = window.FB;

      			this.FB.Event.subscribe('auth.statusChange',
         		this.props.onStatusChange.bind(this));
    	}
  	}

	render(){
		return(
			<div className="s12 m8 l8 offset-l2 offset-m2">

       <div className='section center'>
        <div className="fb-login-button"
        data-max-rows="1"
        data-size="large"
        data-button-type="continue_with"
        data-show-faces="false"
        data-auto-logout-link="true"
        data-use-continue-as="false"
        data-scope='public_profile,email'
        >
      </div>
      </div>
          {this.state.message}
			</div>
			)
	}


}

export default FacebookLogin;



// WEBPACK FOOTER //
// ./src/components/FacebookLogin.js